import React, { useContext, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import NavbarContext from '../../navbar/context'
import {
  setBackPathname,
  setClosePathname,
  setIsBackButtonVisible,
  setIsCloseButtonVisible,
} from '../../navbar/context/action'
import MainLayout from '../../../shared/layout/main-layout/MainLayout'
import AppContext from '../../context'
import RulesView from './RulesView'

export type RulesParamsType = {
  locationCode: string
  organizationId: string
  goalId: string
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface RulesProps {}

const Rules = ({}: RulesProps) => {
  const { state } = useContext(AppContext)
  const { contextDispatch: navbarContextDispatch } = useContext(NavbarContext)

  const { locationCode, organizationId, goalId } = useParams<RulesParamsType>()

  const navigate = useNavigate()

  useEffect(() => {
    if (!state.amount) {
      navigate('/blad')
    }
  }, [])

  useEffect(() => {
    setBackPathname(
      navbarContextDispatch,
      `/${locationCode}/${organizationId}/${goalId}/kwota`
    )
    setClosePathname(navbarContextDispatch, `/${locationCode}`)
    setIsBackButtonVisible(navbarContextDispatch, true)
    setIsCloseButtonVisible(navbarContextDispatch, true)
  }, [])

  return (
    <>
      <MainLayout withSideImage withNavbar>
        <RulesView />
      </MainLayout>
    </>
  )
}

export default Rules
